export enum InvalidLotNumberReason {
  PRODUCT_CODE = "product_code",
  WEB_LINK = "web_link",
}

const WEB_LINK_PATTERN = /^(https?:\/\/|www\.)/i;

// A QR code that encodes a URL types the whole link into the lot field.
export function isWebLink(lotNumber: string): boolean {
  return WEB_LINK_PATTERN.test(lotNumber.trim());
}
